import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const suggesties = [
  { label: 'Inkopen uit China', href: '/inkopen-uit-china', icon: 'ri-global-line' },
  { label: 'Onze diensten', href: '/diensten', icon: 'ri-briefcase-4-line' },
  { label: 'Hoe het werkt', href: '/hoe-het-werkt', icon: 'ri-route-line' },
  { label: 'Veelgestelde vragen', href: '/faq', icon: 'ri-question-answer-line' },
  { label: 'Contact', href: '/contact', icon: 'ri-mail-send-line' },
  { label: 'Blog', href: '/blog', icon: 'ri-newspaper-line' },
];

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F7F8FA] flex flex-col">
      {/* Topbar */}
      <header className="bg-white border-b border-[#0A1628]/8 px-6 py-4 flex items-center justify-between">
        <Link to="/" className="cursor-pointer">
          <img
            src="https://static.readdy.ai/image/15bdf5788918520e40e960585d4ea965/3037d4ed8e2d758e66815cdcd69eb3cd.png"
            alt="DUC - Direct uit China"
            className="h-14 w-auto object-contain"
          />
        </Link>
        <Link
          to="/"
          className="flex items-center gap-2 text-[#0A1628]/60 hover:text-[#3B9EE8] text-sm font-500 transition-colors cursor-pointer"
        >
          <i className="ri-home-line" />
          Naar homepage
        </Link>
      </header>

      {/* Hoofd content */}
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-xl w-full text-center">
          {/* 404 groot getal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="relative mb-8"
          >
            <span
              className="font-heading font-900 text-[#0A1628]/6 select-none pointer-events-none leading-none"
              style={{ fontSize: 'clamp(6rem, 25vw, 11rem)' }}
            >
              404
            </span>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="absolute inset-0 flex items-center justify-center"
            >
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-[#3B9EE8]/10 border-2 border-[#3B9EE8]/25">
                <i className="ri-search-line text-[#3B9EE8] text-3xl" />
              </div>
            </motion.div>
          </motion.div>

          {/* Tekst */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <h1 className="font-heading font-800 text-[#0A1628] text-2xl md:text-3xl mb-3">
              Oeps! Pagina niet gevonden
            </h1>
            <p className="text-[#0A1628]/55 text-base leading-relaxed mb-8">
              De pagina die je zoekt bestaat niet meer of is verplaatst.<br />
              Geen zorgen — hier zijn wat nuttige links om je op weg te helpen.
            </p>
          </motion.div>

          {/* Actieknoppen */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="flex flex-wrap justify-center gap-3 mb-10"
          >
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 border border-[#0A1628]/15 hover:border-[#3B9EE8]/50 text-[#0A1628]/70 hover:text-[#3B9EE8] px-5 py-2.5 rounded-lg text-sm font-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Ga terug
            </button>
            <Link
              to="/"
              className="flex items-center gap-2 bg-[#3B9EE8] hover:bg-[#2D85C5] text-white px-5 py-2.5 rounded-lg text-sm font-700 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-line" />
              Naar homepage
            </Link>
            <a
              href="https://wa.me/31624359162?text=Hallo%20Shubam%2C%20ik%20kan%20een%20pagina%20niet%20vinden%20op%20jullie%20website."
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-2 bg-[#25D366]/10 border border-[#25D366]/30 text-[#1a8a45] hover:bg-[#25D366]/20 px-5 py-2.5 rounded-lg text-sm font-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-base" />
              Hulp via WhatsApp
            </a>
          </motion.div>

          {/* Snelkoppelingen */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            <p className="text-[#0A1628]/35 text-xs uppercase tracking-widest mb-4">Of ga direct naar</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {suggesties.map((s) => (
                <Link
                  key={s.href}
                  to={s.href}
                  className="group flex items-center gap-2.5 bg-white border border-[#0A1628]/8 hover:border-[#3B9EE8]/40 rounded-xl px-4 py-3 transition-all cursor-pointer"
                >
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#3B9EE8]/10 group-hover:bg-[#3B9EE8]/20 transition-colors flex-shrink-0">
                    <i className={`${s.icon} text-[#3B9EE8] text-sm`} />
                  </div>
                  <span className="text-[#0A1628]/70 group-hover:text-[#3B9EE8] text-sm font-500 transition-colors text-left leading-snug">{s.label}</span>
                </Link>
              ))}
            </div>
          </motion.div>

          {/* Footer */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7 }}
            className="text-[#0A1628]/25 text-xs mt-10"
          >
            &copy; {new Date().getFullYear()} Direct uit China (DUC) &bull; <Link to="/contact" className="hover:text-[#3B9EE8] transition-colors cursor-pointer">Contact</Link> &bull; <Link to="/faq" className="hover:text-[#3B9EE8] transition-colors cursor-pointer">FAQ</Link>
          </motion.p>
        </div>
      </main>
    </div>
  );
}
